import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { bool, object, string } from 'prop-types';
import { Row, FlexContainer, Column, Text, StatusTag, Icon, MobileWrapper, If, Button } from '../../common';
import { getPickingStatus } from '../../../utils/misc';
import { Tooltip } from 'antd';

const OrderCard = ({ isMobile, data, id }) => {
    const cardContainerStyles = !isMobile ? {
        direction: 'row',
        align: 'center',
        width: '90%'
    } : {
        direction: 'column',
        width: '100%'
    };

    const separatorBorder = isMobile ? '1px solid #E2E2E2' : null;

    const getDeliveryHour = index => moment(get(data, `promise.${index}`, moment()), 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    const getBagging = index => `${get(data, `bagging.${index}`, 0)}`;
    const invoiceUrl = get(data, 'invoiceUrl', null);
    const formUrl = () => window.open('https://forms.office.com/r/qREiTjCBGc');

    const InvoiceURL = ({ desktop }) => {
        const isntValid = (invoiceUrl || '').search('http') === -1;
        return (
            <MobileWrapper hide={desktop} showDesktop={desktop}>
                <Column align='center' justify='center'>
                    <If
                        condition={isntValid}
                        then={<Text text='Boleta no disponible' color='#d3d3d3' semibold centered />}
                        else={<Icon name='download' size={20} color='#1FA02E' pointer onClick={() => window.open(invoiceUrl)} />}
                    />
                </Column>
            </MobileWrapper>
        );
    };

    InvoiceURL.propTypes = {
        desktop: bool
    };

    return (
        <FlexContainer
            padding={18}
            backgroundColor='#FFFFFF'
            boxShadow
            borderRadius={3}
            flex={1}
            mB={18}
            {...cardContainerStyles}
        >
            <Row>
                <Column justify='center' flex={isMobile ? 2 : 1}>
                    <Text text={get(data, 'idOrder', id)} strong size={20} />
                </Column>
                <Column align='center' justify='center' direction={isMobile ? 'row' : 'column'}>
                    <StatusTag
                        status={`order_status.${getPickingStatus(get(data, 'status', 'pending'))}`}
                        tagType={getPickingStatus(get(data, 'status', 1))}
                        fit
                    />
                    <InvoiceURL />
                </Column>
            </Row>
            <Row paddingVertical={isMobile && 16} borderBottom={separatorBorder}>
                <Column align='center' borderRight={separatorBorder}>
                    <Text text={moment(get(data, 'deliveryDate', moment(), 'YYYY-MM-DD')).format('DD/MM/YYYY')} strong size={20} />
                    <Text text='Entrega' size={12} semibold />
                </Column>
                <Column align='center'>
                    <Text text={`${getDeliveryHour('start')} - ${getDeliveryHour('end')}`} strong size={20} />
                    <Text text='Promesa entrega' size={12} semibold />
                </Column>
            </Row>
            <Row pT={isMobile && 16}>
                <Column align='center' borderRight={separatorBorder}>
                    <Text text={getBagging('packed')} strong size={20} />
                    <Text text='Embolsados' semibold size={12} />
                </Column>
                <Column align='center' borderRight={separatorBorder}>
                    <Text text={getBagging('unpacked')} strong size={20} />
                    <Text text='Productos sueltos' semibold size={12} centered />
                </Column>
                <Column align='center'>
                    <Text text={getBagging('total')} strong size={20} />
                    <Text text='Total bultos' semibold size={12} />
                </Column>
                <InvoiceURL desktop />
                <MobileWrapper hide showDesktop>
                    <Column align='center' justify='center'>
                        <Tooltip title='Registrar control'>
                            <div>
                                <Icon name='clipboard' size={20} color='#1FA02E' pointer onClick={formUrl} />
                            </div>
                        </Tooltip>
                    </Column>
                </MobileWrapper>
            </Row>
            <MobileWrapper>
                <Row pT={9}>
                    <Button text='Registrar control' onClick={formUrl} />
                </Row>
            </MobileWrapper>
        </FlexContainer>
    );
};

OrderCard.propTypes = {
    isMobile: bool,
    data: object,
    id: string
};

export default OrderCard;
